import React from "react";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";

export default function LinkBase({ children, sx = [], ...props }) {
	const { variant = "p3-link-bold", ...rest } = { ...props };
	return (
		<Link href="#" underline="always" {...rest}>
			<Typography sx={{ ...sx }} variant={variant}>
				&nbsp;{children.trim()}&nbsp;
			</Typography>
		</Link>
	);
}

LinkBase.propTypes = {
	/**
	 * Link Children
	 */
	children: PropTypes.node.isRequired,
	/**
	 * Optional sx (styling) properties
	 */
	sx: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

LinkBase.defaultProps = {
	children: null,
	sx: {},
};
